var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
var EmptyState = function (_a) {
    var icon = _a.icon, title = _a.title, description = _a.description, children = _a.children;
    return (_jsxs(Stack, __assign({ alignItems: 'center', justifyContent: 'center', gap: 1, sx: {
            py: 10,
            textAlign: 'center',
        } }, { children: [icon &&
                _jsx(Box, __assign({ sx: { color: 'grey.400', display: 'flex', '& svg': { fontSize: 44 } } }, { children: icon })), _jsx(Typography, __assign({ variant: 'h6' }, { children: title })), description &&
                _jsx(Typography, __assign({ variant: 'body2', color: 'text.secondary' }, { children: description })), children &&
                _jsx(Stack, __assign({ direction: 'row', gap: 1, sx: { mt: 1.5 } }, { children: children }))] })));
};
export default EmptyState;
